// src/components/ui/tooltip.jsx
import React from 'react';
import { Button } from './button';

const Tooltip = ({ children, position, visible, onDismiss, showDismissButton = true }) => {
  if (!visible) return null;
  
  return (
    <div className={`
      absolute z-50 p-4 rounded-lg shadow-2xl drop-shadow-2xl
      border-2 border-yellow-400
      bg-amber-50
      text-stone-900
      max-w-[250px]
      text-sm
      animate-tooltip-enter
      ${position}
    `}>
      <div className="space-y-3">
        <div>{children}</div>
        {showDismissButton && (
          <Button 
            onClick={onDismiss}
            className="w-full bg-stone-800 hover:bg-stone-900 text-white transition-colors leading-none"
            size="sm"
          >
            OK
          </Button>
        )}
      </div>
    </div>
  );
};

export { Tooltip };